const getCurrentItemOrder = (items) =>
  items.length ? `${parseInt(items[items.length - 1].order, 10) + 1}` : '1';

export default getCurrentItemOrder;
